import PropTypes from 'prop-types';
import React, { Fragment, useContext } from 'react';
import { AuthContext } from '../../../common/Auth';
import { formatPriceFixedDecimalPlaces } from '../../../common/PriceFormat';
import {
  getDiscountPrice,
  numberWithCommas2,
  showCurrencycodeSymbol,
} from '../../../helpers/product';
import { useThemeSettingsData } from '../../../layouts/state/useThemeSettingsData';
import { useProductPriceToShow } from '../state/useProductPriceToShow';

const ProductPriceUni = ({
  productPrice,
  usePointsAsCurrency,
  showSell,
  showSellPrice,
  finalProductDiscPrice,
  finalDiscountedPrice,
  productDiscount,
  finalProductPrice,
  currency,
  mainClass,
  decimalsToShow,
  isPrefixOnPriceEnabled,
  prefixOnPriceText,
}) => {
  const discountedPrice = getDiscountPrice(productPrice, productDiscount);
  const { themeSettingsData } = useContext(AuthContext);
  const { productSettings } = useThemeSettingsData({ themeSettingsData });

  const { getPointsFromValue, getPointsValue } = useProductPriceToShow({ productSettings });
  const isDiscounted =
    finalProductDiscPrice === 0 || Number(finalProductPrice) === 0
      ? false
      : finalProductDiscPrice !== Number(finalProductPrice);

  return (
    <div className={`antera-product-price-container ${mainClass}`}>
      {usePointsAsCurrency ? (
        <span className="antera-product-price-text">{getPointsValue(finalProductPrice)}</span>
      ) : (
        <>
          {discountedPrice !== null ? (
            <Fragment>
              <span className="antera-product-price-text">
                {showCurrencycodeSymbol(currency) +
                  numberWithCommas2(
                    formatPriceFixedDecimalPlaces(finalDiscountedPrice, decimalsToShow),
                    decimalsToShow,
                  )}
              </span>{' '}
              <span className="antera-product-price-sale-text old">
                {showCurrencycodeSymbol(currency) +
                  numberWithCommas2(
                    formatPriceFixedDecimalPlaces(finalProductPrice, decimalsToShow),
                    decimalsToShow,
                  )}
              </span>
            </Fragment>
          ) : (
            <>
              {isPrefixOnPriceEnabled && prefixOnPriceText && <span>{prefixOnPriceText} </span>}{' '}
              <span
                className={`antera-product-price-text ${
                  showSellPrice && isDiscounted ? 'breakable-price' : ''
                }`}
              >
                {showCurrencycodeSymbol(currency) +
                  numberWithCommas2(
                    showSell && showSellPrice
                      ? formatPriceFixedDecimalPlaces(finalProductPrice, decimalsToShow)
                      : formatPriceFixedDecimalPlaces(finalProductDiscPrice, decimalsToShow),
                    decimalsToShow,
                  )}
              </span>
              {showSell && showSellPrice && isDiscounted && (
                <span className="antera-product-price-sale-text">
                  &nbsp;
                  {showCurrencycodeSymbol(currency) +
                    numberWithCommas2(
                      formatPriceFixedDecimalPlaces(finalProductDiscPrice, decimalsToShow),
                      decimalsToShow,
                    )}
                </span>
              )}
            </>
          )}
        </>
      )}
    </div>
  );
};

ProductPriceUni.propTypes = {
  productPrice: PropTypes.string,
  usePointsAsCurrency: PropTypes.bool,
  showSell: PropTypes.bool,
  showSellPrice: PropTypes.bool,
  finalProductDiscPrice: PropTypes.number,
  finalDiscountedPrice: PropTypes.number,
  productDiscount: PropTypes.number,
  finalProductPrice: PropTypes.string,
  currency: PropTypes.string,
  mainClass: PropTypes.string,
};

export default ProductPriceUni;
